import { useGetHirerAccountQuery } from 'src/graphql/generated';

import { useAccountContext } from './useAccountContext';

// This might return NULL if this data has not been set up for a hirer
export const useHirerAccount = () => {
  const { data: accountContext } = useAccountContext();
  const skip = !accountContext;

  // Even if accountContext is still null we need to call this hook
  // (with skip: true) to comply with the rule of hooks in React
  const { loading, error, data } = useGetHirerAccountQuery({
    skip,
  });

  return {
    // Force loading to come back as 'true' if we don't have the account info yet
    loading: skip || loading,
    error,
    // This can actually be NULL from the graph if it hasn't been set up
    data: data?.hirerAccount,
  };
};
